
import React ,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { withRouter }         from 'react-router-dom';
import { connect }            from 'react-redux';
import { Divider, DatePicker, Checkbox, Button, Tooltip, Select, Pagination } from 'antd';

import CreateTransferCostrReport from './TransferCostReport/eachRepoert';
// import tarnsferHistoryReport from '../UsageDetail/TransferHistory/transferHistory';
import { on_migration_progress, clear_migration, refresh_migrations_history, aws_migrations_history,aws_migrations_retry} from "../../../actions/migrations";
import {refresh_rm, refresh_profile}   from "../../../actions/auth";
import CreateTransferReport from '../../UserDashboard/TransferHistory/EachTransfer/eachTransfer';

import "./usageDetail.scss";

class UserUsageDeatil extends Component{
    constructor(props) {
        super(props)

        let transferCostData=[
            {
                source:'AWS to Wasabi',
                totalTransfer: '10 GB',
                totalCost: '$30',
            },
            {
                source:'Azure to Wasabi',
                totalTransfer: '1 GB',
                totalCost: '$10',
            },
            {
                source:'Generic S3 to Wasabi',
                totalTransfer: '4.3 GB',
                totalCost: '$2',
            },
            {
                source:'Wasabi to Wasabi',
                totalTransfer: '0 GB',
                totalCost: '0',
            },
           

        ];
        this.state = {
            transferCostData :transferCostData,

            awshistory: [],
            user:{},
            migration:{},
            migrations:{},
            disabledRetry:[],
            downloadUrl:null,
            history : [],
        }
    }

    componentDidMount() {
        this.props.aws_migrations_history(this.props.user.id)
        this.props.refresh_migrations_history()
        this.props.refresh_rm()
        // this.stats_loop()
    }

    componentWillReceiveProps(props) {
        this.setState({migrations:props.ongoing, history:props.history, awshistory:props.awshistory, user:props.user, awsLoading:props.awsLoading})
        // console.log("migrations", props.awshistory);
    }

    

    // onChange(date, dateString) {
    //     console.log(date, dateString);
    // }


    render(){
        const { Option } = Select;
        const { user } = this.props;
        let counter = 0;

        let {speeds, speed_stat={}, transferred_stat={}, remaining_stat={},
        history:{today:today_history=[], yesterday:yesterday_history=[], week:week_history=[]}={},
        awshistory:{today:aws_today_history=[], YesterdayList:aws_yesterday_history=[], ThisWeek:aws_week_history=[]}={}, migrations={}, downloadUrl, awsLoading} = this.state;

        const transferCostTableHeader = <ul>
                                            <li>Direction</li>
                                            <li>Total Transfer</li>
                                            <li>Total Cost</li>
                                            <li>Detail</li>
                                        </ul>

        const transferCostReport = this.state.transferCostData.map((data,index)=>{
            return(
                <div>
                    <Divider/>
                    <CreateTransferCostrReport 
                        key = {index}
                        source = {data.source}
                        totalTransfer = {data.totalTransfer}
                        totalCost = {data.totalCost}
                    />
                </div>
            )
        })


        const recentTransferTableHeader = <ul>
                                            <li>User</li>
                                            <li>Direction</li>
                                            <li>Source Bucket</li>
                                            <li>Destination Bucket</li>
                                            <li>Transfer Size</li>
                                            <li>Total Object</li>
                                            <li>Initiation Date</li>
                                            <li>Completion Date</li>
                                        </ul>

        // console.log("aws history", aws_week_history);
        const ReportList = aws_week_history.slice(0, 5).map((t,index)=>{
            return(
                <div>
                    <Divider/>
                    <CreateTransferReport 
                        key = {index}
                        direction = {t.SourceCloud}
                        source = {t.SourceBucket}
                        destination = {t.DestinationBucket}
                        size = {t.TotalSize}
                        date = {t.BatchTransferDateTime}
                    />
                </div>
            )
            counter++;
        })

        return(
            <div className="usage-detail-wrapper">
                <div className="filter-wrapper">
                    <div className="header">
                        <h3>Account Name: CBS</h3>
                        <div className="user-dropdown">
                            <h3>User:</h3>
                            <Select defaultValue="all" style={{ width: 120 }}>
                                <Option value="all">ALL</Option>
                                <Option value="jack">Jack</Option>
                                <Option value="lucy">Lucy</Option>
                                <Option value="mike">Mike</Option>
                            </Select>
                        </div>
                    </div>
                    <div className="filter-content">
                        <div className="period-wrapper">
                            <h4 className="period-header">
                                <span>1</span>Period:
                            </h4>
                            <div className="period-content">
                                <div className="start-date">
                                    <h4>Start Date</h4>
                                    <DatePicker  />
                                </div>
                                <div className="end-date">
                                    <h4>End Date</h4>
                                    <DatePicker  />
                                </div>
                            </div>
                        </div>
                        <Divider type="vertical" />
                        <div className="source-wrapper">
                            <h4 className="source-header">
                                <span>2</span>Direction:
                            </h4>
                            <div className="source-content">
                                <div className="left">
                                    <Checkbox>AWS to Wasabi</Checkbox>
                                    <Checkbox>Azure to Wasabi</Checkbox>
                                </div>
                                <div className="right">
                                    <Checkbox>Generic S3 to Wasabi</Checkbox>
                                    <Checkbox>Wasabi to Wasabi</Checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Button 
                        className="filter-usage-btn"
                        type="primary" 
                        // onClick={() => history.push('/addProvider')}
                        >
                        Filter
                    </Button>
                </div>
                
                <div className="total-transfer-cost">
                    <div className="header">
                        <h3 className="title-left">Total Transfer/Cost Report</h3>
                        <h3 className="title-right">Last Update: 04/21/2001 - 11:00 AM</h3>
                    </div>
                    <div className="table-header">
                        {transferCostTableHeader}
                    </div>
                    <div>
                        {transferCostReport}
                    </div>
                </div>

                <div className="recent-transfer-wrapper">
                    <div className="header">
                        <h3 className="title-left">Transfer History</h3>
                        <h3 className="title-right">Download Report</h3>
                    </div>
                    <div className="table-header">
                        {recentTransferTableHeader}
                    </div>
                    <div>
                        {ReportList}
                    </div>
                    <Divider/>
                    <div className="page-pagination">
                        <Pagination size="small" total={500} defaultPageSize={10}/>
                    </div>
                </div>

                {/* <div>
                    hi
                        {tarnsferHistoryReport}
                </div> */}
                
            </div>
        )
    }
}

export default withRouter(
    connect(({migrations={},auth}) => ({user : auth.user,ongoing:migrations.ongoing, history:migrations.history, awshistory:migrations.awshistory, awsLoading:migrations.awsLoading}), dispatch => bindActionCreators({on_migration_progress, clear_migration, refresh_migrations_history, aws_migrations_history, refresh_rm, refresh_profile, aws_migrations_retry}, dispatch))(UserUsageDeatil));
